module.exports = __webpack_public_path__ + "static/media/ic_more_details.073dda0e.svg";